var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5939_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.51119 87.0813C-4.48874 64.3258 2.04663 39.3158 20.1839 23.3869C38.2778 7.52141 63.8135 4.20646 85.3154 14.9873L469.006 199.827C489.579 209.765 504.167 227.63 509.904 248.821L84.2928 243.621L4.694 89.8053C4.25672 88.9252 3.86262 88.003 3.51119 87.0813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7886 269.218L6.60802 423.255C6.17052 424.114 5.79701 424.972 5.48803 425.872C-2.48921 448.648 4.11083 473.615 22.2486 489.521C33.4847 499.347 47.584 504.316 61.7056 504.142C70.4303 504.035 79.1522 501.966 87.252 497.877L469.25 313.167C489.886 303.185 504.452 285.256 510.144 264.022L84.7889 269.239L84.7886 269.218Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5939_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendComment);
export default __webpack_public_path__ + "static/media/send-comment.3cbfa38414b3912283a9f29ab0c674d2.svg";
export { ForwardRef as ReactComponent };